import React, { useEffect, useState } from "react";
import PageHeader from "@/components/PageHeader";
import api from "@/api/client";
import { Card } from "@/components/ui/card";
import { fmtDateTime, fromNow } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { BellRing, CheckCheck } from "lucide-react";
import { toast } from "sonner";

export default function Notifications() {
    const [items, setItems] = useState([]);

    const load = () => api.get("/notifications").then((r) => setItems(r.data.items));

    useEffect(() => { load(); }, []);

    const markRead = async (id) => {
        await api.post(`/notifications/${id}/read`);
        load();
    };
    const markAll = async () => {
        await api.post("/notifications/read-all");
        toast.success("All notifications marked read");
        load();
    };

    return (
        <div className="space-y-6" data-testid="notifications-page">
            <PageHeader
                title="Notifications"
                subtitle="Task assignments, deadline alerts, updates"
                actions={
                    <Button variant="outline" onClick={markAll} data-testid="mark-all-read">
                        <CheckCheck size={14} className="mr-1.5" /> Mark all read
                    </Button>
                }
            />
            <Card>
                <ul>
                    {items.map((n) => (
                        <li
                            key={n.id}
                            className={`flex items-start gap-3 p-4 border-b last:border-b-0 border-slate-100 hover:bg-slate-50/60 transition-colors ${
                                n.read ? "" : "bg-blue-50/40"
                            }`}
                            data-testid={`notif-${n.id}`}
                        >
                            <div className="w-9 h-9 rounded-md bg-blue-50 text-primary grid place-items-center shrink-0">
                                <BellRing size={16} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="text-sm font-medium text-slate-800">{n.title}</div>
                                <div className="text-sm text-slate-600">{n.message}</div>
                                <div className="text-xs text-slate-400 mt-1">{fromNow(n.created_at)} · {fmtDateTime(n.created_at)}</div>
                            </div>
                            {!n.read && (
                                <button
                                    className="text-xs text-primary hover:underline"
                                    onClick={() => markRead(n.id)}
                                >
                                    Mark read
                                </button>
                            )}
                        </li>
                    ))}
                    {items.length === 0 && (
                        <li className="text-center text-sm text-slate-500 py-12">All caught up.</li>
                    )}
                </ul>
            </Card>
        </div>
    );
}
